var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersManagementUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3334 26.667V9.46699L2.7334 3.80033L5.1334 2.66699L8.26673 9.40033H23.7334L26.8667 2.66699L29.2667 3.80033L26.6667 9.46699V26.667H5.3334ZM13.3334 17.3337H18.6667C19.0445 17.3337 19.3614 17.2057 19.6174 16.9497C19.8734 16.6937 20.001 16.3772 20.0001 16.0003C19.9992 15.6234 19.8712 15.307 19.6161 15.051C19.361 14.795 19.0445 14.667 18.6667 14.667H13.3334C12.9556 14.667 12.6392 14.795 12.3841 15.051C12.129 15.307 12.001 15.6234 12.0001 16.0003C11.9992 16.3772 12.1272 16.6941 12.3841 16.951C12.641 17.2079 12.9574 17.3354 13.3334 17.3337ZM8.00006 24.0003H24.0001V12.067H8.00006V24.0003Z",
    fill: "#2A3467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersManagementUnselected);
export default __webpack_public_path__ + "static/media/orders-management-unselected.0eb2a168fe208776d39787368b986b61.svg";
export { ForwardRef as ReactComponent };